export default "__VITE_PUBLIC_ASSET__e20fd393__"